import OverlayTrigger from "@rio-cloud/rio-uikit/OverlayTrigger"
import Tooltip from "@rio-cloud/rio-uikit/Tooltip"
import { FormattedMessage } from "react-intl"
import { MenuItemProps } from "@rio-cloud/rio-uikit/MenuItem"

export const mainRunDownloadMenuItem = (onSelect: () => void): MenuItemProps => ({
    onSelect,
    value:
        <OverlayTrigger
            placement={"bottom"}
            overlay={
                <Tooltip id="tooltip" allowOnTouch width={300} textAlignment={"left"}>
                    <FormattedMessage id="mainRun.download.button.popover.text"/>
                </Tooltip>
            }
        >
            <div>
                <span className="uikit-icon icon-cloud-download margin-right-5"/>
                <FormattedMessage id={"common.download"}/>
            </div>
        </OverlayTrigger>
})
